import routes from "@/utils/routes";

const v5 = (state: any) => {
  return {
    ...state,
    viewGuides: routes
      .filter((route) => route.title)
      .reduce<{ [pathKey: string]: boolean }>((finalObject, route) => {
        return { ...finalObject, [route.path!]: false };
      }, {}),
  };
};

export default v5;
